import { z } from "zod";

export const triggerNodeSchema = z.object({
  nodeId: z.string(),
  title: z.string().min(1, "Please enter valid title"),
  phrases: z
    .array(z.object({ value: z.string() }))
    .refine((value) => value.length > 0, {
      message: "Phrase should not be empty",
    })
    .refine((value) => new Set(value).size === value.length, {
      message: "Phrase should not contain duplicates",
    }),
  isValid: z.boolean().default(true),
  frustrationEnabled: z.boolean().nullable(),
});

export type TriggerNodeSchema = z.infer<typeof triggerNodeSchema>;

export const defaultTriggerNodeValues: TriggerNodeSchema = {
  nodeId: "",
  title: "",
  phrases: [
    {
      value: "",
    },
  ],
  isValid: true,
  frustrationEnabled: null,
};
